import { Model } from 'core/models';

export class Status extends Model {
  public id?: number;
  public code?: string;
  public name?: string;
}
